import _ from 'lodash';

export const camelToTitle = (input: string): string => _.startCase(input || '');
